export default __webpack_public_path__ + "locales/vi/ChangePhoneDialog.json?hash=a11ab56c7eb35a3a881a94dfed62bfc5";